export default "__VITE_ASSET__CfZnp792__"